function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_232_314)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.4872 0.723877H1.51245V43.2762H27.4872V0.723877Z",
  fill: "#CCCECF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4406 0.771285V43.2288H1.55925V0.771285H27.4406ZM27.534 0.676514H1.46582V43.3236H27.534V0.676514Z",
  fill: "#606770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.534 0.676514H1.46582V21.1471H27.534V0.676514Z",
  fill: "#84868E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2756 11.3919C22.2969 6.8195 18.6593 3.09534 14.1508 3.07379C9.64239 3.05224 5.97035 6.74146 5.94911 11.3139C5.92787 15.8863 9.56546 19.6105 14.0739 19.632C18.5824 19.6536 22.2544 15.9644 22.2756 11.3919Z",
  fill: "#CFD1D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1113 3.10163C18.6045 3.10163 22.2466 6.79582 22.2466 11.3515C22.2466 15.9071 18.6045 19.6013 14.1113 19.6013C9.61801 19.6013 5.97594 15.9071 5.97594 11.3515C5.97594 6.79582 9.61801 3.10163 14.1113 3.10163ZM14.1113 3.04382C9.59372 3.04382 5.91895 6.77117 5.91895 11.3524C5.91895 15.9337 9.59372 19.661 14.1113 19.661C18.6288 19.661 22.3036 15.9337 22.3036 11.3524C22.3036 6.77117 18.6288 3.04382 14.1113 3.04382Z",
  fill: "#606770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1852 19.3446C18.5371 19.303 22.0318 15.6913 21.9908 11.2776C21.9498 6.86387 18.3886 3.31959 14.0366 3.36119C9.68469 3.4028 6.18999 7.01453 6.231 11.4282C6.27201 15.8419 9.83321 19.3862 14.1852 19.3446Z",
  fill: "#A0A1A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1111 3.38887C18.4409 3.38887 21.9624 6.96079 21.9624 11.3515C21.9624 15.7423 18.4399 19.3142 14.1111 19.3142C9.78231 19.3142 6.25983 15.7423 6.25983 11.3515C6.25983 6.96079 9.78231 3.38887 14.1111 3.38887ZM14.1111 3.33105C9.74307 3.33105 6.2019 6.92194 6.2019 11.3525C6.2019 15.783 9.74307 19.3739 14.1111 19.3739C18.4792 19.3739 22.0203 15.783 22.0203 11.3525C22.0203 6.92194 18.4792 3.33105 14.1111 3.33105Z",
  fill: "#606770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8971 3.76987L11.7887 3.77555C11.4579 3.84474 11.2271 4.13474 11.2524 4.47876L11.2701 4.58869L11.2645 4.58301L12.3969 9.06284L12.4334 9.16046C12.5446 9.39265 12.6735 9.48078 12.9155 9.54523L13.0239 9.55091V9.5566H15.199V9.55091L15.3074 9.54523C15.5064 9.50353 15.7185 9.36137 15.7895 9.16046L15.826 9.05621L15.8316 9.06189L16.9528 4.58206L16.9706 4.47781C16.9958 4.13379 16.765 3.84379 16.4342 3.77461L16.3259 3.76892H16.3202H11.8915H11.8971V3.76987Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1113 12.92C14.9617 12.92 15.6511 12.222 15.6511 11.361C15.6511 10.5 14.9617 9.802 14.1113 9.802C13.2609 9.802 12.5715 10.5 12.5715 11.361C12.5715 12.222 13.2609 12.92 14.1113 12.92Z",
  fill: "#606770",
  stroke: "#606770",
  strokeWidth: 0.3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.28859 16.5819L8.34091 16.6786C8.54647 16.9506 8.90339 17.0349 9.19771 16.8624L9.2874 16.798L9.2846 16.8065L12.7697 13.8241L12.8407 13.7483C12.9986 13.5464 13.021 13.39 12.9734 13.1408L12.9313 13.0394L12.9369 13.0365L11.9914 11.0501L11.9858 11.053L11.9335 10.9563C11.8092 10.7923 11.5906 10.6606 11.3822 10.6833L11.2738 10.6957L11.2766 10.6871L6.81139 11.6112L6.71142 11.6396C6.39468 11.7666 6.23771 12.103 6.32086 12.4347L6.36291 12.5361L6.36478 12.5418L8.29046 16.5867L8.28859 16.581V16.5819Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9333 16.5819L19.881 16.6786C19.6754 16.9506 19.3185 17.0349 19.0242 16.8624L18.9345 16.798L18.9373 16.8065L15.4522 13.8241L15.3812 13.7483C15.2233 13.5464 15.2009 13.39 15.2485 13.1408L15.2906 13.0394L15.285 13.0365L16.2305 11.0501L16.2361 11.053L16.2884 10.9563C16.4127 10.7923 16.6313 10.6606 16.8397 10.6833L16.9481 10.6957L16.9453 10.6871L21.4105 11.6112L21.5105 11.6396C21.8272 11.7666 21.9842 12.103 21.901 12.4347L21.859 12.5361L21.8571 12.5418L19.9314 16.5867L19.9333 16.581V16.5819Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.34313 12.3381H1.90967V20.5757H6.34313V12.3381Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.1,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.34248 11.4966V11.4871C6.33594 11.199 6.24998 10.9232 6.06498 10.7517L6.05283 10.7403C5.56137 10.2844 4.96059 10.0342 4.34859 10.0361H3.90384C3.29185 10.0352 2.69107 10.2854 2.1996 10.7403L2.18839 10.7517C2.00339 10.9232 1.91743 11.199 1.91089 11.4871V11.5127V12.3362H6.34435V11.4966H6.34248Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.1,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.7902 2.31604H4.77142C3.84642 2.31604 3.0896 3.08369 3.0896 4.02192V14.6429C3.0896 15.5812 3.84642 16.3488 4.77142 16.3488H6.53359",
  stroke: "#AC6C32",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.8688 3.3092H6.5075C5.5825 3.3092 4.82568 4.07685 4.82568 5.01509V9.94603",
  stroke: "#AC6C32",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.2037 13.4821H6.32728C6.29013 13.4821 6.26001 13.5126 6.26001 13.5503V16.8597C6.26001 16.8974 6.29013 16.9279 6.32728 16.9279H7.2037C7.24085 16.9279 7.27097 16.8974 7.27097 16.8597V13.5503C7.27097 13.5126 7.24085 13.4821 7.2037 13.4821Z",
  fill: "#C6C9CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.2037 13.4821H6.32728C6.29013 13.4821 6.26001 13.5126 6.26001 13.5503V16.8597C6.26001 16.8974 6.29013 16.9279 6.32728 16.9279H7.2037C7.24085 16.9279 7.27097 16.8974 7.27097 16.8597V13.5503C7.27097 13.5126 7.24085 13.4821 7.2037 13.4821Z",
  stroke: "#606770",
  strokeWidth: 0.1,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.344 18.7551H18.186C17.7375 18.7551 17.374 19.1238 17.374 19.5787C17.374 20.0335 17.7375 20.4023 18.186 20.4023H21.344C21.7925 20.4023 22.156 20.0335 22.156 19.5787C22.156 19.1238 21.7925 18.7551 21.344 18.7551Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.1,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.05054 1.22424V20.4855",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1477 1.22424V20.4855",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2456 1.22424V20.4855",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3428 1.22424V20.4855",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 2.10938H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 2.5946H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 3.08081H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 3.56702H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 4.05225H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 4.53845H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 5.02454H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 5.50977H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 5.99597H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 6.48218H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 6.96741H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 7.45361H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 7.9397H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 8.42493H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 8.91113H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 9.39734H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 9.88257H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 10.3688H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 10.8549H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 11.3401H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 11.8263H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 12.3125H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 12.7977H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 13.2839H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 13.77H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 14.2552H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 14.7415H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 15.2277H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 15.7129H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 16.1991H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 16.6852H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 17.1704H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 17.6566H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 18.1428H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 18.6281H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 19.1143H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 19.6003H22.4567",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 1.62329H22.4922",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.90112 20.0856H22.4922",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.0497 0.723877H1.51245V21.0997H2.0497V0.723877Z",
  fill: "#CCCECF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.00307 0.771285V21.0523H1.55925V0.771285H2.00307ZM2.0965 0.676514H1.46582V21.1471H2.0965V0.676514Z",
  fill: "#606770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5239 30.6953H19.55V30.5854H19.5444C19.5267 30.5854 19.522 30.592 19.5117 30.6271H19.4958V30.5674H19.6407V30.6271H19.6248C19.6154 30.593 19.6098 30.5854 19.5921 30.5854H19.5865V30.6953H19.6126V30.7152H19.5248V30.6953H19.5239ZM19.6575 30.6953H19.678V30.5873H19.6575V30.5674H19.7332L19.7621 30.6631H19.7659L19.7948 30.5674H19.8687V30.5873H19.8472V30.6953H19.8687V30.7152H19.7948V30.6953H19.8117V30.5939H19.8061L19.7677 30.7152H19.7463L19.7061 30.5939H19.6995V30.6953H19.7173V30.7152H19.6584V30.6953H19.6575Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.55493 32.0023H7.76796V30.8423H7.55493V30.6338H8.36314V30.8423H8.15291V31.2924H8.76024V30.8423H8.5472V30.6338H9.35728V30.8423H9.14425V32.0023H9.35728V32.2108H8.5472V32.0023H8.76024V31.4943H8.15291V32.0023H8.36314V32.2108H7.55493V32.0023Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.46655 32.0117H9.64595V31.2877H9.46655V31.0887H9.99072V32.0108H10.1701V32.2098H9.46655V32.0108V32.0117ZM9.59175 30.7247C9.59175 30.6072 9.67678 30.5162 9.80198 30.5162C9.92718 30.5162 10.015 30.6025 10.015 30.7172C10.015 30.8318 9.92718 30.9228 9.80198 30.9228C9.67678 30.9228 9.59175 30.8413 9.59175 30.7238V30.7247Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2888 32.0023H10.5018V30.8423H10.2888V30.6338H11.0615C11.5502 30.6338 11.7399 30.8328 11.7399 31.1133C11.7399 31.3939 11.5558 31.5995 11.0662 31.5995H10.8868V32.0023H11.1157V32.2108H10.2888V32.0023ZM11.0372 31.4005C11.2661 31.4005 11.3278 31.3019 11.3278 31.1105C11.3278 30.9191 11.2643 30.8328 11.0344 30.8328H10.8859V31.4005H11.0372Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1051 31.6952C12.1191 31.9568 12.2228 32.043 12.3985 32.043C12.5311 32.043 12.6134 31.9881 12.6629 31.8469H12.847C12.804 32.0819 12.6489 32.2354 12.3387 32.2354C11.9705 32.2354 11.7454 32.0051 11.7454 31.6602C11.7454 31.3152 11.993 31.0631 12.3265 31.0631C12.6993 31.0631 12.875 31.3313 12.8582 31.6952H12.1041H12.1051ZM12.1079 31.5445H12.5209C12.5087 31.3171 12.448 31.2261 12.32 31.2261C12.192 31.2261 12.1219 31.3048 12.107 31.5445H12.1079Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9424 32.0117H13.105V31.2876H12.9424V31.0886H13.4292V31.3758C13.4955 31.1673 13.6226 31.064 13.7739 31.064C13.9113 31.064 13.9982 31.1673 13.9982 31.2848C13.9982 31.4023 13.916 31.4904 13.8141 31.4904C13.7123 31.4904 13.6301 31.4307 13.6301 31.3198C13.6301 31.3151 13.6329 31.3075 13.6329 31.3009C13.5693 31.3056 13.4908 31.3777 13.4507 31.517V32.0107H13.6562V32.2097H12.9424V32.0107V32.0117Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.113 31.4317C14.113 30.9408 14.4578 30.5958 14.8642 30.5958C15.0623 30.5958 15.2118 30.665 15.3062 30.7825L15.3557 30.6006H15.5687V31.2279H15.3352C15.2408 30.9379 15.1081 30.792 14.9119 30.792C14.6895 30.792 14.5335 30.9569 14.5335 31.408C14.5335 31.8591 14.6961 32.024 14.9633 32.024C15.1969 32.024 15.3314 31.844 15.3716 31.5805H15.5986C15.5585 31.988 15.3296 32.2486 14.9091 32.2486C14.4251 32.2486 14.113 31.9179 14.113 31.4317Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6902 32.0117H15.8509V30.7608H15.6902V30.557H16.1985V31.3408C16.2835 31.1702 16.3994 31.065 16.5787 31.065C16.817 31.065 16.917 31.228 16.917 31.4602V32.0117H17.0749V32.2108H16.4442V32.0117H16.5694V31.5085C16.5694 31.4346 16.5554 31.3739 16.5199 31.3379C16.4937 31.3142 16.4582 31.3 16.4087 31.3C16.3003 31.3 16.1985 31.4128 16.1985 31.573V32.0117H16.3209V32.2108H15.6902V32.0117Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.1758 32.0117H17.3552V31.2877H17.1758V31.0887H17.6999V32.0108H17.8793V32.2098H17.1758V32.0108V32.0117ZM17.301 30.7247C17.301 30.6072 17.386 30.5162 17.5112 30.5162C17.6364 30.5162 17.7242 30.6025 17.7242 30.7172C17.7242 30.8318 17.6364 30.9228 17.5112 30.9228C17.386 30.9228 17.301 30.8413 17.301 30.7238V30.7247Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9841 32.0117H18.1635V30.7608H17.9841V30.557H18.5111V32.0117H18.6905V32.2108H17.9841V32.0117Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.7952 32.0117H18.9746V30.7608H18.7952V30.557H19.3221V32.0117H19.5015V32.2108H18.7952V32.0117Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5571 31.3739C20.6515 31.2972 20.7842 31.2545 20.9187 31.2545C21.2971 31.2545 21.4457 31.4754 21.4457 31.7199C21.4457 31.9909 21.2523 32.2496 20.8412 32.2496C20.5226 32.2496 20.2927 32.1179 20.2927 31.9094C20.2927 31.7872 20.3703 31.6914 20.4983 31.6914C20.6188 31.6914 20.6777 31.7748 20.6777 31.8592C20.6777 31.9312 20.6422 31.9909 20.588 32.0241C20.6254 32.0554 20.6992 32.0819 20.7767 32.0819C20.9496 32.0819 21.0458 31.9672 21.0458 31.7606C21.0458 31.554 20.9533 31.4536 20.7814 31.4536C20.6917 31.4536 20.5945 31.4943 20.5188 31.5569L20.3675 31.5114L20.4217 30.7162L20.4787 30.6632C20.6319 30.721 20.8234 30.7447 20.9701 30.7447C21.1355 30.7447 21.242 30.7134 21.3579 30.6537L21.4195 30.7712C21.313 30.9702 21.1477 31.0584 20.9421 31.0584C20.7935 31.0584 20.6795 31.0271 20.5852 30.9911L20.5571 31.3749V31.3739Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.26471 22.2284H2.90107C2.73337 22.2284 2.59741 22.3663 2.59741 22.5364V24.2423C2.59741 24.4124 2.73337 24.5503 2.90107 24.5503H6.26471C6.43242 24.5503 6.56837 24.4124 6.56837 24.2423V22.5364C6.56837 22.3663 6.43242 22.2284 6.26471 22.2284Z",
  fill: "#7D8189"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.26464 22.3232C6.3805 22.3232 6.47487 22.4189 6.47487 22.5364V24.2423C6.47487 24.3598 6.3805 24.4556 6.26464 24.4556H2.901C2.78514 24.4556 2.69077 24.3598 2.69077 24.2423V22.5364C2.69077 22.4189 2.78514 22.3232 2.901 22.3232H6.26464ZM6.26464 22.1337H2.901C2.68237 22.1337 2.50391 22.3147 2.50391 22.5364V24.2423C2.50391 24.4641 2.68237 24.6451 2.901 24.6451H6.26464C6.48327 24.6451 6.66173 24.4641 6.66173 24.2423V22.5364C6.66173 22.3147 6.48327 22.1337 6.26464 22.1337Z",
  fill: "#606770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4872 20.4742H1.51245V21.0997H27.4872V20.4742Z",
  fill: "#434244"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4406 20.5217V21.0524H1.55925V20.5217H27.4406ZM27.534 20.4269H1.46582V21.1471H27.534V20.4269Z",
  fill: "#434244"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4872 0.723877H22.5352V21.0997H27.4872V0.723877Z",
  fill: "#CCCECF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4405 0.771285V21.0523H22.582V0.771285H27.4405ZM27.534 0.676514H22.4885V21.1471H27.534V0.676514Z",
  fill: "#606770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.6462 13.7531H23.376V18.9986H26.6462V13.7531Z",
  fill: "#91939A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5995 13.8005V18.9513H23.4228V13.8005H26.5995ZM26.693 13.7057H23.3293V19.046H26.693V13.7057Z",
  fill: "#606770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4872 0.723877H1.51245V1.26881H27.4872V0.723877Z",
  fill: "#CCCECF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4406 0.771285V1.22145H1.55925V0.771285H27.4406ZM27.534 0.676514H1.46582V1.31622H27.534V0.676514Z",
  fill: "#606770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.693 12.394H23.3293V13.3408H26.693V12.394Z",
  fill: "#023171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5479 13.0887H24.8132V13.0157H24.6263V12.902H24.7964V12.8281H24.6263V12.7181H24.8132V12.6451H24.5479V13.0887Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.7109 13.0887H25.9763V13.0157H25.7894V12.902H25.9595V12.8281H25.7894V12.7181H25.9763V12.6451H25.7109V13.0887Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0279 12.6451H24.9495V13.0887H25.2064V13.0157H25.0279V12.6451Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4093 12.6451H25.3298V13.0887H25.5877V13.0157H25.4093V12.6451Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7713 12.9171L23.6545 12.6451H23.5789V13.0887H23.6545V12.8233L23.7377 13.0129H23.805L23.8881 12.8233V13.0887H23.9647V12.6451H23.8881L23.7713 12.9171Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.3576 12.9105C26.3913 12.8963 26.4146 12.8631 26.4146 12.8243V12.738C26.4146 12.6868 26.3735 12.6451 26.3231 12.6451H26.1138V13.0887H26.1923V12.9171H26.2754L26.3576 13.0887H26.4445L26.3586 12.9105H26.3576ZM26.3352 12.8072C26.3352 12.8281 26.3184 12.8442 26.2988 12.8442H26.1923V12.7181H26.2988C26.3193 12.7181 26.3352 12.7352 26.3352 12.7551V12.8063V12.8072Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.3226 12.9721C24.3226 12.9958 24.304 13.0157 24.2797 13.0157H24.2311C24.2077 13.0157 24.1881 12.9967 24.1881 12.9721V12.6451H24.1096V12.9901C24.1096 13.0441 24.1535 13.0887 24.2068 13.0887H24.303C24.3572 13.0887 24.4011 13.0441 24.4011 12.9892V12.6451H24.3226V12.9721Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.00083 21.7565H2.16187V25.0213H7.00083V21.7565Z",
  fill: "#434244"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.26266 22.417H2.89902C2.83452 22.417 2.78223 22.47 2.78223 22.5355V24.2413C2.78223 24.3068 2.83452 24.3598 2.89902 24.3598H6.26266C6.32716 24.3598 6.37945 24.3068 6.37945 24.2413V22.5355C6.37945 22.47 6.32716 22.417 6.26266 22.417Z",
  fill: "#A4A9AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.26258 22.5118C6.27473 22.5118 6.28594 22.5232 6.28594 22.5355V24.2414C6.28594 24.2537 6.27473 24.2651 6.26258 24.2651H2.89895C2.8868 24.2651 2.87559 24.2537 2.87559 24.2414V22.5355C2.87559 22.5232 2.8868 22.5118 2.89895 22.5118H6.26258ZM6.26258 22.3223H2.89895C2.78309 22.3223 2.68872 22.418 2.68872 22.5355V24.2414C2.68872 24.3589 2.78309 24.4546 2.89895 24.4546H6.26258C6.37844 24.4546 6.47281 24.3589 6.47281 24.2414V22.5355C6.47281 22.418 6.37844 22.3223 6.26258 22.3223Z",
  fill: "#7D8189"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.0616 22.526H7.49146V24.2508H11.0616V22.526Z",
  fill: "#A4A9AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.27617 23.8367C9.52025 23.8367 9.71812 23.636 9.71812 23.3885C9.71812 23.1409 9.52025 22.9402 9.27617 22.9402C9.03209 22.9402 8.83423 23.1409 8.83423 23.3885C8.83423 23.636 9.03209 23.8367 9.27617 23.8367Z",
  fill: "#434244"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_232_314"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 44,
  fill: "white"
})));

var SvgHiPerChill5 = function SvgHiPerChill5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 44,
    viewBox: "0 0 29 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHiPerChill5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HiPerChill_5.0d7bb57b.svg";
export { ForwardRef as ReactComponent };